import SelectDropdown from "components/reuseable/Dropdown/SelectDropdown"
import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import {
  setActiveMenuSidebar,
  setMenuSidebar,
} from "redux/global/globalActions";
import { setAnakPerusahaan } from "redux/profil/profilActions";
import useRedux from "redux/useRedux";
import icSelected from "./assets/images/icons/icon-selected.svg";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";
import { t } from "i18next";
import dummy from "assets/images/dummy/1.png";
import { getHeaderUrlImg } from "redux/global/globalActions";
import { uAPI } from "api/config";
import FroalaEditorView from "components/reuseable/FormInput/FroalaEditorTextArea";




const LayoutDetail = ({ children }) => {
  const lang = localStorage.getItem('i18nextLng');

  const location = useLocation();
  const { pathname } = location;
  // console.log('pathname', pathname)
  const {
    dispatch,
    global: { menu, menuSidebar, activeMenuSidebar, headerUrlImg },
    profil: { anakPerusahaan },
  } = useRedux();

  const [header, setHeader] = useState("");

  const normalizePath = (path = "") => path.split("?")[0].replace(/\/+$/, "");

  const pathMatches = (candidatePath = "", currentPath = "") => {
    const candidateSegments = normalizePath(candidatePath).split("/").filter(Boolean);
    const currentSegments = normalizePath(currentPath).split("/").filter(Boolean);

    if (candidateSegments.length !== currentSegments.length) {
      return false;
    }

    return candidateSegments.every((segment, index) => (
      segment?.startsWith(":") || segment === currentSegments[index]
    ));
  };

  const findNestedMenu = (items = [], currentPath = "") => {
    for (const item of items) {
      if (pathMatches(item?.path, currentPath)) {
        return { active: item, parents: [] };
      }

      if (item?.sub_menu?.length > 0) {
        const nestedMatch = findNestedMenu(item.sub_menu, currentPath);

        if (nestedMatch) {
          return {
            active: nestedMatch.active,
            parents: [item, ...nestedMatch.parents],
          };
        }
      }
    }

    return null;
  };

  const matchedMenu = menu.reduce((result, currentMenu) => {
    if (result || !currentMenu?.child?.length) {
      return result;
    }

    const match = findNestedMenu(currentMenu.child, pathname);

    if (!match) {
      return result;
    }

    return {
      menuSidebar: currentMenu,
      activeMenuSidebar: match.active,
      activeParents: match.parents,
    };
  }, null);

  const pathFind = matchedMenu?.activeMenuSidebar || "";
  const findSubMenu = matchedMenu?.menuSidebar || null;

  // console.log("PATHHHHHHH ", findSubMenu)
  useEffect(() => {
    if (findSubMenu) {
      dispatch(setMenuSidebar(findSubMenu));
    }
    if (pathFind) {
      dispatch(setActiveMenuSidebar(pathFind));
    }
    return () => {
      dispatch(setMenuSidebar(null));
      dispatch(setActiveMenuSidebar(null));
    };
  }, [findSubMenu, pathFind]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    dispatch(getHeaderUrlImg());
  }, [dispatch, location])

  useEffect(() => {
    // console.log("useEffect headerUrlImg", headerUrlImg)
    if (!headerUrlImg || !menuSidebar?.title) return;
  
    const found = headerUrlImg.find(item => item.image_name === menuSidebar?.title);
    
    // console.log("headerUrlImg Found", found)
    if (found) {
      setHeader(found); // bisa juga setHeader(found.image) kalau kamu hanya butuh url-nya
    }
  }, [headerUrlImg, menuSidebar?.title]);

  const anakPerusahaanClick = (data) => {
    // console.log('anakPerusahaanClick', data)
    dispatch(
      setAnakPerusahaan({
        selected: data,
      })
    );
  };

  let tataKelola = [];
  let other = [];

  const hasActiveNestedMenu = (item) => {
    if (!item?.sub_menu?.length) {
      return false;
    }

    return item.sub_menu.some((submenu) => (
      activeMenuSidebar?.path === submenu?.path || hasActiveNestedMenu(submenu)
    ));
  };

  const renderSidebarItems = (items = [], depth = 0) => items.map((item, index) => {
    const hasSubMenu = item?.sub_menu?.length > 0;
    const isActive = activeMenuSidebar?.path === item?.path;
    const isNestedActive = hasActiveNestedMenu(item);

    if (hasSubMenu) {
      return (
        <Disclosure key={`${item?.path || item?.title}-${index}`} defaultOpen={isActive || isNestedActive}>
          {({ open }) => (
            <>
              <Disclosure.Button className={`flex w-full justify-between rounded-lg px-4 py-2 text-left text-sm text-[15px] hover:bg-[#F0F2F2] focus:outline-none focus-visible:ring focus-visible:ring-gray-500 focus-visible:ring-opacity-75 ${depth > 0 ? 'ml-4' : ''} ${isActive || isNestedActive ? 'text-active font-semibold bg-[#F0F2F2]' : 'text-gray-1500'}`}>
                <div className="my-1 text-[15px] ">
                  {lang === "en" ? (item?.title_en ? item?.title_en : item?.title) : item?.title}
                </div>
                <ChevronUpIcon
                  className={`${open ? "rotate-180 transform" : ""} h-5 w-5 text-primary-500`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="pt-2">
                {renderSidebarItems(item?.sub_menu, depth + 1)}
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      );
    }

    return (
      <Link
        key={`${item?.path || item?.title}-${index}`}
        className={`my-1 p-[14px] text-[15px] hover:bg-[#F0F2F2] hover:rounded-lg block ${depth > 0 ? 'ml-4' : ''} ${isActive ? "text-active font-semibold bg-[#F0F2F2] rounded-lg" : ""}`}
        to={`${item?.isEksternal ? "#" : item?.path}`}
        onClick={() => {
          if (item?.isEksternal) {
            window.open(item?.path, "_blank");
          }
        }}
      >
        {lang === "en" ? (item?.title_en ? item?.title_en : item?.title) : item?.title}
      </Link>
    );
  });

// console.log("test2", header);
// console.log("test3", menuSidebar?.title);

// console.log("PATHFINDSA",pathFind)
  return (
    <>
      <div className="mt-[120px]">
      <div className="slideshow-header w-screen h-screen relative overflow-hidden">
        {/* Teks di tengah */}
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center z-10">
          <div className="text-white text-[40px] font-semibold uppercase text-center drop-shadow-lg">
            <div className="froala-view-wrapper">
              {
                header?.description && header.image_name === menuSidebar.title ? 
                <FroalaEditorView
                  model={lang === "en" ? (header?.description_en ? header?.description_en : header?.description) :header?.description}
                /> :
                <div className="text-white text-[40px] font-semibold uppercase text-center">
                  {lang === "en" ? (menuSidebar?.title_en ? menuSidebar?.title_en : menuSidebar?.title) : menuSidebar?.title}
                </div> 
              }
            </div>
          </div>
        </div>

        {/* Gambar background */}
        <img
            src={header?.image ? uAPI + header.image : dummy}
            alt="banner"
            className="w-screen h-screen object-cover absolute top-0 left-0"
            loading="lazy"   // 🟢 tambahkan lazy loading
        />
      </div>
      
        <div className="section pt-[30px]">
          {/* <div className="flex flex-row flex-wrap md:flex-nowrap md:divide-x-2"> */}
          <div className="md:grid md:grid-cols-4 md:divide-x-2 ">
            <div className="hidden md:flex md:flex-col md:mr-2">
              {/* {findSubMenu?.title && <div className="text-active text-[15px] uppercase font-bold mb-4">{findSubMenu?.title}</div>} */}
              {menuSidebar?.title && (
                <div className="text-active text-[15px] uppercase font-bold mb-4">
                  {lang === "en" ? (menuSidebar?.title_en ? menuSidebar?.title_en : menuSidebar?.title) : menuSidebar?.title}
                </div>
              )}
              {/* {findSubMenu?.title?.length > 0 && (
                                findSubMenu?.child?.map((val, ind) => {
                                    return (
                                        <Link key={ind} to={val?.path} className={`my-1 p-[14px] text-[15px] hover:bg-[#F0F2F2] hover:rounded-lg ${pathname === val?.path ? 'text-active font-semibold bg-[#F0F2F2] rounded-lg' : ''}`}>
                                            {val?.title}
                                        </Link>
                                    )
                                })
                            )} */}
              {menuSidebar?.title?.length > 0 &&
                (() => {
                  menuSidebar?.child?.forEach((val) => {
                    val?.title === "Praktik Tata Kelola" ||
                    val?.title === "Laporan Penilaian GCG"
                      ? tataKelola.push(val)
                      : other.push(val);
                  });
                  return null;
                })()}
              {other?.length > 0 && renderSidebarItems(other.filter((val) => val?.title === "Manual GCG" || val?.title === "Whistleblowing System"))}
              {menuSidebar?.title === "GCG" && tataKelola.length > 0 ? (
                // <BasicDropdown
                //     className={`my-1 p-[14px] text-[15px] hover:bg-[#F0F2F2] hover:rounded-lg 'text-active font-semibold bg-[#F0F2F2] rounded-lg'`}
                //     title={'Tata Kelola'}
                //     items={tataKelola}
                //     onClickItems={onClickMenu}
                // />

                <Disclosure>
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full justify-between rounded-lg  px-4 py-2 text-left text-sm text-[15px] p-[14px] text-gray-1500 hover:bg-[#F0F2F2] focus:outline-none focus-visible:ring focus-visible:ring-gray-500 focus-visible:ring-opacity-75">
                        <div className="my-1 text-[15px] ">{t('praktik_tata_kelola')}</div>
                        <ChevronUpIcon
                          className={`${
                            open ? "rotate-180 transform" : ""
                          } h-5 w-5 text-primary-500`}
                        />
                      </Disclosure.Button>
                      {tataKelola?.map((val, ind) => {
                        return (
                          <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
                            <Link
                              key={ind}
                              className={`my-1 p-[14px] text-[15px] hover:bg-[#F0F2F2] hover:rounded-lg ${
                                activeMenuSidebar?.path === val?.path
                                  ? "text-active font-semibold bg-[#F0F2F2] rounded-lg"
                                  : ""
                              }`}
                              to={`${val?.isEksternal ? "#" : val?.path}`}
                              onClick={(e) => {
                                if (val?.isEksternal) {
                                  window.open(val?.path, "_blank");
                                }
                              }}
                            >
                              {lang === "en" ? (val?.title_en ? val?.title_en : val?.title) : val?.title}
                            </Link>
                          </Disclosure.Panel>
                        );
                      })}
                    </>
                  )}
                </Disclosure>
              ) : (
                ""
              )}

              {other?.length > 0 && renderSidebarItems(other.filter((val) => val?.title !== "Manual GCG" && val?.title !== "Whistleblowing System"))}

              {pathFind?.path === "/wilayah-kerja-anak-perusahaan" &&
                anakPerusahaan?.data?.length > 0 && (
                  <div className="py-6 border-t-2">
                    {anakPerusahaan?.data?.map((val, ind) => {
                      return (
                        <div
                          key={ind}
                          className={`cursor-pointer my-1 p-[14px] text-[15px] hover:bg-[#F0F2F2] items-center hover:rounded-lg ${
                            anakPerusahaan?.selected?.id === val?.id
                              ? "text-active gap-2 flex flex-row items-start font-semibold bg-[#F0F2F2] rounded-lg"
                              : ""
                          }`}
                          onClick={() => anakPerusahaanClick(val)}
                        >
                          {anakPerusahaan?.selected?.id === val?.id ? (
                            <img src={icSelected} alt="icons" style={{
                              objectFit:"cover",
                              position:"relative"
                            }}/>
                          ) : (
                            ""
                          )}
                          {val?.company_name}
                        </div>
                      );
                    })}
                  </div>
                )}
            </div>
            
            {/* <div>
                            {
                                dropdown?dropdown.map((data)=>

                                ):null
                            }
                        </div> */}
            <div className="md:col-span-3 md:flex md:flex-col pl-0 md:pl-[20px]">
              {pathFind?.path === "/wilayah-kerja-anak-perusahaan" &&
                anakPerusahaan?.data?.length > 0 && (
                  <div className="py-6 border-t-2 md:hidden">
                    <SelectDropdown
                        items={anakPerusahaan?.data}
                        onClickItems={anakPerusahaanClick}
                        selectedTitle={anakPerusahaan?.selected?.company_name}
                        selectedValue={anakPerusahaan?.selected}
                    />
                  </div>
                )}
              <div className="section-detail flex flex-col">
                <Outlet context={pathFind} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <img src={bgFooter} alt="icon" className="relative object-fill w-full" /> */}
    </>
  );
};
export default LayoutDetail;
